import { ExtraCategory as ExtraCategoryProto } from "../../../../gen/witbooking/backoffice/common/common_pb";
import { ExtraCategory } from "../../domain/ExtraCategory.enum";

const fromProtoMap: Record<ExtraCategoryProto, ExtraCategory> = {
  [ExtraCategoryProto.EXTRA_CATEGORY_NONE]: ExtraCategory.NONE,
  [ExtraCategoryProto.EXTRA_CATEGORY_VEHICLE]: ExtraCategory.VEHICLE,
  [ExtraCategoryProto.EXTRA_CATEGORY_FACILITIES]: ExtraCategory.FACILITIES,
};

const toProtoMap: Record<ExtraCategory, ExtraCategoryProto> = {
  [ExtraCategory.NONE]: ExtraCategoryProto.EXTRA_CATEGORY_NONE,
  [ExtraCategory.VEHICLE]: ExtraCategoryProto.EXTRA_CATEGORY_VEHICLE,
  [ExtraCategory.FACILITIES]: ExtraCategoryProto.EXTRA_CATEGORY_FACILITIES,
};

export class ExtraCategoryMapper {
  /** A value this front does not know is read as *No category*. */
  static toDomain(proto: ExtraCategoryProto): ExtraCategory {
    return fromProtoMap[proto] ?? ExtraCategory.NONE;
  }

  static toProto(category: ExtraCategory): ExtraCategoryProto {
    return toProtoMap[category];
  }
}
